<template>
  <div class="lm-banner">
    <div class="center">
      <div class="banner-overlay1">
        <span class="title">加速企业大模型  AI 应用的落地</span>
        <p>端到端的 LLMOps：模型的微调、提示</p>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Lm-Banner',
}
</script>

<style>
.lm-banner {
  width: 100vw;
  height: 38.5vw;
  overflow-y: hidden;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url("../../assets/images/ailmbanner.png");
}

.lm-banner .center {
  width: auto !important;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-left: 4vw;
}

.lm-banner .banner-overlay1 {
  padding-top: 10vw;
  color: #FFFFFF;
  text-align: left;
}


.lm-banner .banner-overlay1 .title {
  font-size: 12px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 16px;
  display: inline;
}

.lm-banner .banner-overlay1 p {
  font-size: 6px;
  font-weight:300;
  color: #FFFFFF;
  line-height: 10px;
  opacity: 0.7;
  margin-top: 6px;
}

.lm-banner .btn-contactUs {
  width: 24vw;
  margin-top: 6vw;
  height: 4vw;
  cursor: pointer;
  color: #fff;
  border: 1px solid #ffffff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 300;
  padding: 2vw;
}
</style>
<style></style>


// WEBPACK FOOTER //
// src/page/h5/lm-banner.vue